

const Number = [
  {
    year: 2026,
    month: '01',
    day: 21,
    shift: 1
  },
  {
    year: 2026,
    month: '01',
    day: 21,
    shift: 2
  },
  {
    year: 2026,
    month: '01',
    day: 22,
    shift: 1
  },
  {
    year: 2026,
    month: '01',
    day: 22,
    shift: 2
  },
  {
    year: 2026,
    month: '01',
    day: 23,
    shift: 1
  },
  {
    year: 2026,
    month: '01',
    day: 23,
    shift: 2
  },
  {
    year: 2026,
    month: '01',
    day: 24,
    shift: 1
  },
  {
    year: 2026,
    month: '01',
    day: 24,
    shift: 2
  },
  {
    year: 2026,
    month: '01',
    day: 28,
    shift: 1
  },
  {
    year: 2026,
    month: '01',
    day: 28,
    shift: 2
  },



]


export default Number;